import { Link } from 'react-router-dom';
import { useState, FormEvent } from 'react';

export default function Footer() {
  const [newsletterStatus, setNewsletterStatus] = useState<'idle' | 'success'>('idle');

  const handleNewsletter = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setNewsletterStatus('success');
    e.currentTarget.reset();
  };

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading text-base font-bold">
                  G
                </span>
              </div>
              <span className="font-heading text-xl font-semibold text-background-50">
                Ghalib Chai
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              A Taste of Tranquility. Premium dine-in tea experience and
              authentic green tea products crafted with love and tradition.
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-facebook-circle-line', label: 'Facebook' },
                { icon: 'ri-twitter-x-line', label: 'Twitter' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800/50 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', href: '/' },
                { label: 'Menu', href: '/menu' },
                { label: 'Green Tea Shop', href: '/shop' },
                { label: 'About Us', href: '/about' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'Contact', href: '/contact' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-background-400 text-sm hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Contact Info
            </h4>
            <ul className="space-y-2.5">
              <li className="text-background-400 text-sm flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-500" />
                <span>
                  123 Artisan Lane
                  <br />
                  Cultural District, CA 90210
                </span>
              </li>
              <li>
                <a
                  href="tel:+15551234567"
                  className="text-background-400 text-sm flex items-center gap-2 hover:text-primary-400 transition-colors"
                >
                  <i className="ri-phone-line text-primary-500" />
                  (555) 123-4567
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@ghalibchai.com"
                  className="text-background-400 text-sm flex items-center gap-2 hover:text-primary-400 transition-colors"
                >
                  <i className="ri-mail-line text-primary-500" />
                  hello@ghalibchai.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Newsletter
            </h4>
            <p className="text-background-400 text-sm mb-3">
              Stay updated on new blends, special offers, and events.
            </p>
            {newsletterStatus === 'success' ? (
              <div className="p-3 bg-primary-900/50 text-primary-300 text-xs rounded-md">
                Thank you for subscribing!
              </div>
            ) : (
              <form onSubmit={handleNewsletter} className="flex gap-2">
                <input
                  type="email"
                  required
                  placeholder="your@email.com"
                  className="flex-1 px-3 py-2 rounded-md bg-background-800/50 border border-background-700/50 text-background-200 text-sm placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-3 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  Join
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} Ghalib Chai. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-background-300 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}